module.exports = __webpack_public_path__ + "img/10业务领域-img3.f080b664.jpg";